import React, { ReactElement, useContext } from "react";
import Content from "./Content";
import { Button as MuiButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ActionType, AppContext } from "@cdv/jazz-ui";
import { Resource } from "../utils";

export default function Button(props: any): ReactElement {
  const { children, variant, url, color } = props;
  const navigate = useNavigate();
  const { getUrl } = useContext(AppContext);
  return (
    <MuiButton
      variant={variant}
      sx={{ mb: "10px" }}
      fullWidth
      color={color}
      size="large"
      onClick={() => navigate(getUrl(Resource.Page, ActionType.SHOW, { id: url }))}
    >
      <Content contentValue={children} />
    </MuiButton>
  );
}
